var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team"},[_c('h1',{staticClass:"text-sm-subtitle-1 grey--text"},[_vm._v("Team")])])
}]

export { render, staticRenderFns }